import * as React from 'react';

import './title.styles.scss';

export type TitleProps = {
  text: React.ReactNode;
  margin?: string | number;
};

export const Title: React.FC<TitleProps> = (props) => {
  const { text, margin } = props;

  return (
    <h6 className="FhqDesignToolTitle" style={{ margin: margin ?? '12px 0' }}>
      {text}
    </h6>
  );
};